import React from "react";
import { motion } from "framer-motion";
import { values } from "../../constants/siteContent";
import { fadeInUp, staggerContainer } from "../../lib/animations";

export const ValuesSection = () => {
  return (
    <section id="values" data-testid="values-section" className="py-24 md:py-28 bg-[#F4F4F5]">
      <div className="max-w-5xl mx-auto px-6">
        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={staggerContainer} className="text-center mb-16 md:mb-[4.5rem]">
          <motion.p variants={fadeInUp} className="text-[#D1111A] font-semibold tracking-[0.2em] uppercase mb-3">What Drives Us</motion.p>
          <motion.h2 variants={fadeInUp} className="font-editorial text-4xl md:text-5xl text-[#0A0A0A] italic">Our Values</motion.h2>
        </motion.div>

        <motion.div className="flex flex-col md:flex-row items-center justify-center gap-12 md:gap-16" initial="hidden" whileInView="visible" viewport={{ once: true }} variants={staggerContainer}>
          {values.map((value, index) => (
            <motion.div key={value.title} variants={fadeInUp} className="text-center" data-testid={`value-${index}`}>
              <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-[#0A0A0A] flex items-center justify-center">
                <value.icon className="w-10 h-10 text-white" />
              </div>
              <h3 className="font-editorial text-xl text-[#0A0A0A] italic">{value.title}</h3>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};